import React, { Component, Fragment } from 'react';
import DataDisplay from './DataDisplayContainer';
import SurveyProjectSurveyListContainer from './SurveyProjectSurveyListContainer';

class SurveyDataContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trackingSurvey: null,
    };
    this.trackSurvey = this.trackSurvey.bind(this);
  }

  trackSurvey(id) {
    const { trackingSurvey } = this.state;

    if (trackingSurvey === id) {
      this.setState({ trackingSurvey: null });
    } else {
      this.setState({ trackingSurvey: id });
    }
  }

  render() {
    const { trackingSurvey } = this.state;
    return (
      <Fragment>
        {/* info */}
        <div className={`mt10 ${!trackingSurvey ? 'hidden' : ''}`}>
          {trackingSurvey ? <DataDisplay surveyId={trackingSurvey} /> : null}
        </div>
        {/* list survey */}
        <SurveyProjectSurveyListContainer
          trackSurvey={this.trackSurvey}
          trackingSurvey={trackingSurvey}
        />
      </Fragment>
    );
  }
}

export default SurveyDataContainer;
